import { render } from "./takeAlook.vue?vue&type=template&id=75fb591d"
import script from "./takeAlook.vue?vue&type=script&lang=js"
export * from "./takeAlook.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__